import React from "react";
import useReveal from "@/hooks/useReveal";

const Privacy: React.FC = () => {
  useReveal();
  return (
    <main className="iav-page" data-testid="privacy-page">
      <section className="iav-page-hero">
        <div className="iav-page-hero-inner">
          <span className="iav-tag-line" data-reveal>Legal</span>
          <h1 data-reveal>PRIVACY<br /><span className="iav-accent">POLICY</span></h1>
          <p className="lead" data-reveal>Last updated: 1 January 2026</p>
        </div>
      </section>

      <article className="iav-article" data-reveal>
        <p>Ideation Audio Visual (“Ideation”, “we”, “us”) respects your privacy and is committed to protecting personal data collected through our website at www.ideationav.com.</p>

        <h2>Information We Collect</h2>
        <p>We collect information you provide directly when you submit forms on our website — such as your name, email address, phone number, company, event details and any attachments you choose to share. We also collect basic technical information (such as browser type, device type and pages visited) for analytics purposes.</p>

        <h2>How We Use Your Information</h2>
        <p>We use the information you provide to respond to your enquiry, prepare proposals, schedule meetings, process job applications, and operate our business with you. We do not sell or rent your personal data to third parties.</p>

        <h2>Storage &amp; Security</h2>
        <p>Submitted data is stored securely in our managed database and file storage providers (Supabase). Access is restricted to authorised Ideation team members. We retain submissions only as long as is needed to serve your enquiry, fulfil our obligations or comply with applicable law.</p>

        <h2>Cookies &amp; Analytics</h2>
        <p>Our website may use cookies to remember preferences and to power analytics (e.g. Google Analytics 4). You can choose to disable cookies via your browser settings. We do not use cookies for advertising or cross-site tracking.</p>

        <h2>Your Rights</h2>
        <p>You may request access to, correction of, or deletion of your personal data at any time. To exercise any of these rights, please email <a href="mailto:info@ideationav.com">info@ideationav.com</a> with the subject line “Privacy Request”.</p>

        <h2>Updates To This Policy</h2>
        <p>This policy may be updated from time to time. Material changes will be reflected on this page with a revised “Last updated” date.</p>

        <h2>Contact</h2>
        <p>Ideation Audio Visual<br />Warehouse 15B DREC, Jabal Ali, Dubai, UAE<br /><a href="mailto:info@ideationav.com">info@ideationav.com</a> &nbsp;·&nbsp; <a href="tel:+97143211919">+971 4 321 1919</a></p>
      </article>
    </main>
  );
};
export default Privacy;
